import React from 'react';
import AnimatedLogos from './AnimatedLogos';
import './Logos.css';
import { useLocation } from "react-router-dom";

export const LogosComponent = () => {
  // Definir los parámetros a pasar
  const defaultColor = "#008080";  // Color por defecto para el tornado
  const durations = [2000, 2000, 2000, 2000, 0];  // Tiempos de aparición de cada paso

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const logo1 = queryParams.get("logo_uno");
  const logo2 = queryParams.get("logo_dos");
  const tornadoColor = queryParams.get("color") || defaultColor; // Usa color por defecto si no está presente

  return (
    <div className="Logos">
      <AnimatedLogos 
        logo1={logo1} 
        logo2={logo2} 
        tornadoColor={tornadoColor} 
        durations={durations} 
      />
    </div>
  );
};
